import { getActiveScenario, getActiveScenarioKey, getActiveScenarioInfo, switchScenario, listScenarios } from '@/services/emergencyMapData.js'
import { LONGMEN_GIS_DATA } from './emergencyMapData_longmen.js'
import { YANCHANG_GIS_DATA } from './emergencyMapData_yanchang.js'

const GATEWAY_URL = (process.env.VUE_APP_HYDRO_API_URL || '').replace(/\/$/, '')

// ════════════════════════════════════════
// 龙门镇场景数据
// ════════════════════════════════════════
const LONGMEN_SCENARIO = {
  scenario_id: 'guxian-longmen-flood-emergency',
  scenario_name: '龙门镇禹门口沿河片区黄河洪水应急联动处置',
  metrics: {
    risk_level: 'orange',
    max_stage: 617.38,
    forecast_rain_1h_mm: 38,
    upstream_flow_m3s: 2050,
    impacted_count: 5,
    evacuation_people: 3860,
    warning_window_min: 10,
  },
  impacted_objects: [
    { name: '禹门口桥头商铺带', type: '橙区经营点', people: 420, exceedance_m: 0.5, priority: '第一序列', contact: '禹门口社区网格员', zone: 'orange' },
    { name: '龙门镇沿河居民区', type: '红区居民点', people: 1260, exceedance_m: 0.8, priority: '第一序列', contact: '龙门镇防汛值守室', zone: 'red' },
    { name: '下峪口沿河住户区', type: '红区居民点', people: 680, exceedance_m: 0.7, priority: '第一序列', contact: '下峪口社区主任', zone: 'red' },
    { name: '黄河滩区施工营地', type: '临时工棚', people: 310, exceedance_m: 1.1, priority: '第一序列', contact: '施工总包安全员', zone: 'red' },
    { name: '黄河滩区农田作业带', type: '滩区作业面', people: 1190, exceedance_m: 0.3, priority: '第二序列', contact: '村组联络员', zone: 'yellow' },
  ],
  recommended_plan: {
    name: '龙门镇禹门口沿河片区防汛应急联动方案',
    actions: [
      'T+0 分钟：启动古贤枢纽防汛会商，锁定下泄方案和风险区',
      'T+1 分钟：向龙门镇政府防汛指挥部、禹门口社区、下峪口社区、施工营地发布橙色避险指令',
      'T+3 分钟：封控禹门口大桥，打开广播、警灯、短信和对讲双通道，红区人员只出不进',
      'T+5 分钟：完成红区清户（龙门镇沿河 + 下峪口住户）、桥头商铺封控、物资前置',
      'T+7 分钟：红区和橙区人员到达一级避险点（第一小学/第二小学/观景平台）并登记',
    ],
  },
}

const LONGMEN_SHEET = {
  sheet_id: 'guxian-response-sheet',
  event_id: 'guxian-emergency-event',
  status: 'draft',
  plan_name: '龙门镇禹门口沿河片区防汛应急联动方案',
  risk_level: 'orange',
  gis_data: LONGMEN_GIS_DATA,
  risk_objects: LONGMEN_SCENARIO.impacted_objects,
  actions: LONGMEN_SCENARIO.recommended_plan.actions,
  trigger_conditions: [
    { level: '重点关注', rule: '古贤出库流量连续上涨，龙门水文站预报水位接近警戒线 385.50m；未来 1 小时强降雨或上游来水突增；禹门口大桥、滩区道路出现漫水、回水或交通拥堵。' },
    { level: '临战待命', rule: '龙门水文站水位涨率超过设定阈值；禹门口桥头商铺带开始进水；滩区作业面、施工便道存在被切断风险；预演模型判定 30 分钟内影响龙门镇居民区或下峪口住户区。' },
    { level: '强制转移', rule: '龙门水文站达到红色预警 388.00m；禹门口桥头已连续漫流；滩区作业人员无法在 7 分钟内安全撤离；通信或监测连续失效且无法确认上游洪峰状态。' },
  ],
  infrastructure: [
    { name: '龙门镇政府防汛指挥部', type: '指挥通信', role: '接收枢纽调度指令、发布镇级广播短信、汇总避险点回执' },
    { name: '龙门水文站', type: '水情监测', role: '复核古贤下泄影响、水位涨率和洪峰传播时间' },
    { name: '禹门口大桥封控点', type: '交通封控', role: '控制桥头商铺带、游客车辆和陕晋跨河通行' },
    { name: '龙门镇第一小学', type: '一级避险点', role: '承接沿河居民区首轮转移和人员清点' },
    { name: '龙门镇第二小学（初中部）', type: '一级避险点', role: '承接下峪口住户和滩区人员转移' },
    { name: '禹门口观景平台', type: '一级避险点', role: '承接桥头商铺带商户和游客转移' },
    { name: '龙门镇文化体育广场', type: '二级综合安置点', role: '承接 6-24 小时安置、食品饮水发放和医疗照护' },
    { name: '龙门镇防汛物资仓库', type: '物资仓库', role: '前置救生衣、砂袋、饮用水、食品和对讲设备' },
  ],
  teams: [
    { name: '枢纽工程抢险队', leader: '周伟', members: 24, phone: '133-2222-3301', duty: '闸门、坝后交通、工程险情处置' },
    { name: '龙门镇群众转移队', leader: '韩青', members: 36, phone: '135-1234-5601', duty: '红区敲门、老人儿童协助转移' },
    { name: '交通封控与引导组', leader: '李建国', members: 18, phone: '136-7788-2109', duty: '桥头、低洼路口封控和路线引导' },
    { name: '医疗救护与安置组', leader: '王敏', members: 12, phone: '139-6677-1201', duty: '避险点登记、急救、特殊人群照护' },
    { name: '物资保障组', leader: '赵磊', members: 10, phone: '138-4455-6902', duty: '物资装车、前置、签收回收' },
  ],
  materials: [
    { name: '编织袋/砂袋', count: 5200, unit: '条', place: '龙门镇防汛物资仓库', target: '禹门口桥头、施工营地围挡', manager: '赵磊' },
    { name: '救生衣', count: 760, unit: '件', place: '龙门镇防汛物资仓库', target: '沿河居民区和滩区作业人员', manager: '韩青' },
    { name: '移动照明灯组', count: 12, unit: '套', place: '龙门镇政府大院', target: '夜间转移路线入口和避险点', manager: '周伟' },
    { name: '冲锋舟', count: 4, unit: '艘', place: '黄河岸线抢险停靠点', target: '低洼孤点应急接驳', manager: '李建国' },
    { name: '应急发电机', count: 8, unit: '台', place: '龙门镇政府大院', target: '广播、避险点照明、通信中继', manager: '王敏' },
    { name: '饮用水和方便食品', count: 4200, unit: '人份', place: '龙门镇二级安置物资仓', target: '龙门镇文化体育广场', manager: '赵磊' },
  ],
  evacuation_routes: [
    { name: 'L1 龙门镇沿河居民区→第一小学路线', start: '龙门镇沿河居民区红区入口', via: '沿河西巷 -> 108国道高侧 -> 学校东门', end: '龙门镇第一小学', shelter_level: '一级避险点', distance_km: 1.5, walk_minutes: 7, capacity: 1600, guard: '路线引导员A、交通封控与引导组', backup: 'L1-B 居民区-北塬台地临时点' },
    { name: 'L2 禹门口桥头商铺→观景平台路线', start: '禹门口桥头商铺带', via: '桥西封控点 -> 旅游路高侧 -> 观景平台', end: '禹门口观景平台', shelter_level: '一级避险点', distance_km: 0.8, walk_minutes: 5, capacity: 900, guard: '路线引导员B、禹门口社区网格员', backup: 'L2-B 禹门口桥头-北塬台地' },
    { name: 'L3 下峪口住户→第二小学路线', start: '下峪口沿河住户区', via: '下峪口主街 -> 108国道 -> 学校南门', end: '龙门镇第二小学（初中部）', shelter_level: '一级避险点', distance_km: 2.0, walk_minutes: 8, capacity: 1200, guard: '下峪口社区主任、交通封控与引导组', backup: 'L3-B 下峪口-文化体育广场' },
    { name: 'L4 滩区施工营地→文化体育广场路线', start: '黄河滩区施工营地', via: '施工便道高线 -> 108国道 -> 广场西门', end: '龙门镇文化体育广场', shelter_level: '二级综合安置点', distance_km: 2.5, walk_minutes: 10, capacity: 700, guard: '施工安全员、枢纽工程抢险队', backup: 'L4-B 施工营地-第二小学' },
  ],
  shelters: [
    { name: '龙门镇第一小学', level: '一级避险点', capacity: 1600, manager: '王敏（校长）', supplies: '饮水 1200 人份、急救包 24 套、照明 4 套、帐篷 20 顶', register: '按村组二维码和纸质表双登记' },
    { name: '禹门口观景平台', level: '一级避险点', capacity: 900, manager: '禹门口景区管理处', supplies: '雨衣 500 件、饮水 800 人份、对讲机 6 部、急救包 12 套', register: '商户、游客、居民分区登记' },
    { name: '龙门镇第二小学（初中部）', level: '一级避险点', capacity: 1200, manager: '李建国（校长）', supplies: '安全帽 350 顶、照明 3 套、担架 4 副、折叠床 200 张', register: '施工班组与居民分区点名制' },
    { name: '龙门镇文化体育广场', level: '二级综合安置点', capacity: 2800, manager: '龙门镇民政专干', supplies: '食品 4200 人份、折叠床 800 张、棉被 1200 条、医疗站 1 座', register: '6-24 小时安置和物资发放' },
    { name: '北塬台地临时安置点', level: '临时避险点', capacity: 500, manager: '龙门镇武装部', supplies: '应急照明 2 套、对讲机 3 部、帐篷 50 顶', register: '村组登记制' },
  ],
  warning_chain: [
    { minute: 0, actor: '枢纽值班长', action: '确认古贤下泄、龙门水文站预演结果，向龙门镇政府防汛指挥部发出预案启动令' },
    { minute: 1, actor: '龙门镇政府防汛指挥部', action: '发布短信、广播、对讲指令，打开人员转移和物资前置回执台账' },
    { minute: 3, actor: '路线引导员', action: '到达 L1-L4 路线入口，封控禹门口大桥，设置只出不进封控线' },
    { minute: 5, actor: '敲门组/特殊人群转移组', action: '完成龙门镇沿河居民区和下峪口住户清户，禹门口桥头商铺停业撤离' },
    { minute: 7, actor: '避险点管理员', action: '第一小学、第二小学、观景平台完成首轮人数清点，回传未到人员名单' },
    { minute: 15, actor: '物资保障组', action: '完成砂袋、救生衣、照明、发电机从物资仓库前置签收' },
    { minute: 30, actor: '镇防汛指挥部', action: '复核人员缺口、路线受阻、通信失败三类异常并形成处置回执' },
  ],
  communications: [
    { name: '主通信', tool: '短信平台 + 调度电话', holder: '枢纽值班长/镇防汛办', fallback: '电话失败即切到对讲中继' },
    { name: '村内发布', tool: '高音广播 + 警灯 + 手摇警报器', holder: '广播控制员', fallback: '断电时使用发电机和手摇警报器' },
    { name: '路线协同', tool: 'UHF 对讲机 18 部', holder: '路线引导员、交通封控组', fallback: '对讲失败时每 3 分钟派机动补位员往返传令' },
    { name: '回执闭环', tool: '移动端回执 + 纸质清单', holder: '避险点管理员', fallback: '断网时纸质登记，恢复后补录' },
  ],
  control_zones: [
    { zone: '红区', rule: '黄河主槽近岸 0-50 m、禹门口大桥上下游 100 m、龙门镇首排临河房屋、下峪口沿河住户和滩区临时工棚', action: '强制离开，不设观察点、不堆物资、不停车' },
    { zone: '橙区', rule: '龙门镇临河二排房屋、下峪口社区沿街商铺、禹门口桥头低洼带和短时滞留点', action: '警报后 7 分钟内到一级避险点' },
    { zone: '黄区', rule: '滩区农田作业面、低位道路和农机临停点，只作为穿越撤离区', action: '不长期停留，到一级避险点剩余步行不超过 4 分钟' },
    { zone: '蓝区', rule: '第一小学、第二小学、观景平台（一级）、文化体育广场（二级）、北塬台地（临时）', action: '登记、分区安置、物资发放、医疗照护' },
  ],
  similar_events: [
    { event_id: 'history-2022-datong-0818', title: '青海大通县"8·18"突发山洪复盘', risk_level: 'red', score: 5, summary: '夜间短时强降雨、沟谷快速汇流、可用转移时间极短，适合作为山洪动作链参考。' },
    { event_id: 'history-2024-longmen-01', title: '2024 龙门断面洪水联动处置演练', risk_level: 'orange', score: 4, summary: '验证枢纽下泄、下游广播、物资前置和避险点登记闭环。' },
    { event_id: 'history-2025-guxian-construction', title: '古贤施工营地夜间强降雨撤离演练', risk_level: 'orange', score: 4, summary: '重点检验施工班组点名和临时工棚撤离效率。' },
  ],
  owner: '古贤枢纽防汛值班长',
  source: 'local_response',
}

const LONGMEN_DRILL = {
  drill_id: 'drill-local',
  sheet_id: LONGMEN_SHEET.sheet_id,
  event_id: LONGMEN_SHEET.event_id,
  status: 'draft',
  title: '龙门镇禹门口沿河片区防汛应急联动演练方案',
  scenario: '橙色预警条件下，古贤枢纽下泄调度与龙门镇禹门口沿河片区人员转移、交通封控、物资前置联动演练',
  objectives: [
    '验证枢纽值班长、镇防汛办、村组联络员之间的发令和回执链路。',
    '验证红区、橙区人员 7 分钟内到达一级避险点。',
    '验证砂袋、救生衣、照明、发电机等物资按点位前置和签收。',
    '验证断电、断网、对讲失败情况下的备用通信和人工传令。',
  ],
  steps: [
    { minute: 0, action: '启动防汛会商，确认橙色预警和联动预案', owner: '古贤枢纽防汛值班长' },
    { minute: 1, action: '发布广播、短信、对讲指令，打开回执台账', owner: '龙门镇政府防汛指挥部' },
    { minute: 3, action: '封控禹门口大桥和沿河低位道路，路线引导员到位', owner: '交通封控与引导组' },
    { minute: 5, action: '红区清户（龙门镇沿河 + 下峪口住户），特殊人群由担架车和小型转运车接送', owner: '龙门镇群众转移队' },
    { minute: 7, action: '第一小学、第二小学、观景平台登记人数，反馈未到人员名单', owner: '医疗救护与安置组' },
    { minute: 15, action: '物资从仓库前置到桥头、避险点和施工营地，完成签收', owner: '物资保障组' },
    { minute: 30, action: '复盘通信失败、路线受阻、人员未到三类异常', owner: '枢纽工程抢险队' },
  ],
  roles: LONGMEN_SHEET.teams.map(team => ({ team: team.name, leader: team.leader, responsibility: team.duty || '执行分配任务并回传处置回执。' })),
  materials: LONGMEN_SHEET.materials,
  routes: LONGMEN_SHEET.evacuation_routes,
  shelters: LONGMEN_SHEET.shelters,
  evaluation: ['预警发出到广播响应用时', '红区清户完成率', '一级避险点到达率', '物资前置签收率', '备用通信启用成功率'],
  schedule: { duration_minutes: 90, start_mode: 'manual' },
  owner: LONGMEN_SHEET.owner,
  source: 'local_response',
}

// ════════════════════════════════════════
// 延长县场景数据
// ════════════════════════════════════════
const YANCHANG_SCENARIO = {
  scenario_id: 'yanchang-yanhe-flood-emergency',
  scenario_name: '延长县县城延河沿线山洪防御应急联动处置',
  metrics: {
    risk_level: 'orange',
    max_stage: 803.50,
    forecast_rain_1h_mm: 45,
    upstream_flow_m3s: 820,
    impacted_count: 5,
    evacuation_people: 3550,
    warning_window_min: 8,
  },
  impacted_objects: [
    { name: '中心街临河商铺带', type: '橙区经营点', people: 380, exceedance_m: 0.6, priority: '第一序列', contact: '中心街社区网格员', zone: 'orange' },
    { name: '延河沿岸低洼居民区', type: '红区居民点', people: 1520, exceedance_m: 0.9, priority: '第一序列', contact: '延长县防汛值守室', zone: 'red' },
    { name: '西河子沟汇入口低洼区', type: '红区居民点', people: 560, exceedance_m: 0.8, priority: '第一序列', contact: '西河子沟社区主任', zone: 'red' },
    { name: '延河下游施工营地', type: '临时工棚', people: 240, exceedance_m: 1.2, priority: '第一序列', contact: '施工总包安全员', zone: 'red' },
    { name: '延河下游农田作业带', type: '滩区作业面', people: 850, exceedance_m: 0.4, priority: '第二序列', contact: '村组联络员', zone: 'yellow' },
  ],
  recommended_plan: {
    name: '延长县县城延河沿线片区防汛应急联动方案',
    actions: [
      'T+0 分钟：启动延长县防汛会商，确认延河上游暴雨洪水预警和风险区',
      'T+1 分钟：向延长县政府防汛指挥部、中心街社区、西河子沟社区、施工营地发布橙色避险指令',
      'T+2 分钟：封控延河大桥和中心街沿河路段，打开广播、警灯、短信和对讲双通道，红区人员只出不进',
      'T+5 分钟：完成红区清户（延河沿岸居民区 + 西河子沟低洼区）、商铺封控、物资前置',
      'T+7 分钟：红区和橙区人员到达一级避险点（延长县中学/职业教育中心/体育馆）并登记',
    ],
  },
}

const YANCHANG_SHEET = {
  sheet_id: 'yanchang-response-sheet',
  event_id: 'yanchang-emergency-event',
  status: 'draft',
  plan_name: '延长县县城延河沿线片区防汛应急联动方案',
  risk_level: 'orange',
  gis_data: YANCHANG_GIS_DATA,
  risk_objects: YANCHANG_SCENARIO.impacted_objects,
  actions: YANCHANG_SCENARIO.recommended_plan.actions,
  trigger_conditions: [
    { level: '重点关注', rule: '延河上游持续暴雨，延长县水文站预报水位接近警戒线 799.50m；未来 1 小时强降雨或上游来水突增；延河大桥、中心街沿河路段出现漫水。' },
    { level: '临战待命', rule: '水文站水位涨率超过设定阈值；中心街商铺带开始进水；延河下游施工便道存在被切断风险；预演模型判定 30 分钟内影响县城居民区。' },
    { level: '强制转移', rule: '水文站达到红色预警 803.00m；延河大桥已连续漫流；西河子沟支沟回水倒灌；通信或监测连续失效且无法确认上游洪峰状态。' },
  ],
  infrastructure: [
    { name: '延长县政府防汛指挥部', type: '指挥通信', role: '接收延河上游预警、发布县级广播短信、汇总避险点回执' },
    { name: '延长县水文站', type: '水情监测', role: '复核延河上游来水、水位涨率和洪峰传播时间' },
    { name: '延河大桥封控点', type: '交通封控', role: '控制中心街商铺带、两岸车辆和行人通行' },
    { name: '延长县中学', type: '一级避险点', role: '承接延河沿岸居民区首轮转移和人员清点' },
    { name: '延长县职业教育中心', type: '一级避险点', role: '承接西河子沟住户和下游人员转移' },
    { name: '延长县体育馆', type: '一级避险点', role: '承接下游施工营地和商铺人员转移' },
    { name: '延长县人民广场', type: '二级综合安置点', role: '承接 6-24 小时安置、食品饮水发放和医疗照护' },
    { name: '延长县防汛物资仓库', type: '物资仓库', role: '前置救生衣、砂袋、饮用水、食品和对讲设备' },
  ],
  teams: [
    { name: '县应急抢险队', leader: '陈志强', members: 28, phone: '133-2222-4401', duty: '延河桥头围挡、工程险情处置' },
    { name: '群众转移队', leader: '张文亮', members: 40, phone: '135-1234-5701', duty: '红区敲门、老人儿童协助转移' },
    { name: '交通封控与引导组', leader: '刘建华', members: 20, phone: '136-7788-2209', duty: '延河大桥、低洼路口封控和路线引导' },
    { name: '医疗救护与安置组', leader: '王秀兰', members: 14, phone: '139-6677-1301', duty: '避险点登记、急救、特殊人群照护' },
    { name: '物资保障组', leader: '陈志强', members: 12, phone: '138-4455-7002', duty: '物资装车、前置、签收回收' },
  ],
  materials: [
    { name: '编织袋/砂袋', count: 6000, unit: '条', place: '延长县防汛物资仓库', target: '延河桥头、施工营地围挡', manager: '陈志强' },
    { name: '救生衣', count: 800, unit: '件', place: '延长县防汛物资仓库', target: '沿河居民区和下游作业人员', manager: '张文亮' },
    { name: '移动照明灯组', count: 15, unit: '套', place: '延长县政府大院', target: '夜间转移路线入口和避险点', manager: '陈志强' },
    { name: '冲锋舟', count: 3, unit: '艘', place: '延河岸线抢险停靠点', target: '低洼孤点应急接驳', manager: '刘建华' },
    { name: '应急发电机', count: 10, unit: '台', place: '延长县政府大院', target: '广播、避险点照明、通信中继', manager: '张文亮' },
    { name: '饮用水和方便食品', count: 5000, unit: '人份', place: '延长县二级安置物资仓', target: '延长县人民广场', manager: '陈志强' },
  ],
  evacuation_routes: [
    { name: 'L1 延河沿岸居民区→延长县中学路线', start: '延河沿岸低洼居民区红区入口', via: '沿河西巷 -> 201省道高侧 -> 学校东门', end: '延长县中学', shelter_level: '一级避险点', distance_km: 1.8, walk_minutes: 8, capacity: 1800, guard: '路线引导员A、交通封控与引导组', backup: 'L1-B 居民区-北山台地临时点' },
    { name: 'L2 中心街商铺→人民广场路线', start: '中心街临河商铺带', via: '桥西封控点 -> 兴延街高侧 -> 广场北门', end: '延长县人民广场', shelter_level: '二级综合安置点', distance_km: 0.6, walk_minutes: 4, capacity: 1000, guard: '路线引导员B、中心街社区网格员', backup: 'L2-B 中心街-职业教育中心' },
    { name: 'L3 西河子沟住户→职业教育中心路线', start: '西河子沟汇入口低洼区', via: '西河子沟主街 -> 201省道 -> 职教中心南门', end: '延长县职业教育中心', shelter_level: '一级避险点', distance_km: 1.5, walk_minutes: 6, capacity: 1200, guard: '西河子沟社区主任、交通封控与引导组', backup: 'L3-B 西河子沟-人民广场' },
    { name: 'L4 下游施工营地→人民广场路线', start: '延河下游施工营地', via: '施工便道高线 -> 201省道 -> 广场西门', end: '延长县人民广场', shelter_level: '二级综合安置点', distance_km: 2.2, walk_minutes: 10, capacity: 800, guard: '施工安全员、县应急抢险队', backup: 'L4-B 施工营地-体育馆' },
  ],
  shelters: [
    { name: '延长县中学', level: '一级避险点', capacity: 1800, manager: '张文亮（校长）', supplies: '饮水 1500 人份、急救包 30 套、照明 5 套、帐篷 25 顶', register: '按村组二维码和纸质表双登记' },
    { name: '延长县职业教育中心', level: '一级避险点', capacity: 1200, manager: '刘建华（主任）', supplies: '雨衣 600 件、饮水 1000 人份、对讲机 8 部、急救包 15 套', register: '商户、居民、施工人员分区登记' },
    { name: '延长县人民广场', level: '二级综合安置点', capacity: 3000, manager: '延长县民政专干', supplies: '食品 5000 人份、折叠床 1000 张、棉被 1500 条、医疗站 1 座', register: '6-24 小时安置和物资发放' },
    { name: '延长县体育馆', level: '一级避险点', capacity: 1000, manager: '延长县教体局', supplies: '安全帽 400 顶、照明 4 套、担架 5 副、折叠床 250 张', register: '施工班组与居民分区点名制' },
    { name: '县城北山台地安置点', level: '临时避险点', capacity: 600, manager: '延长县武装部', supplies: '应急照明 3 套、对讲机 4 部、帐篷 60 顶', register: '村组登记制' },
  ],
  warning_chain: [
    { minute: 0, actor: '延长县防汛值班长', action: '确认延河上游暴雨洪水预警，向县政府防汛指挥部发出预案启动令' },
    { minute: 1, actor: '延长县政府防汛指挥部', action: '发布短信、广播、对讲指令，打开人员转移和物资前置回执台账' },
    { minute: 2, actor: '路线引导员', action: '到达 L1-L4 路线入口，封控延河大桥，设置只出不进封控线' },
    { minute: 5, actor: '敲门组/特殊人群转移组', action: '完成延河沿岸居民区和西河子沟低洼区清户，中心街商铺停业撤离' },
    { minute: 7, actor: '避险点管理员', action: '延长县中学、职教中心、体育馆完成首轮人数清点，回传未到人员名单' },
    { minute: 15, actor: '物资保障组', action: '完成砂袋、救生衣、照明、发电机从物资仓库前置签收' },
    { minute: 30, actor: '县防汛指挥部', action: '复核人员缺口、路线受阻、通信失败三类异常并形成处置回执' },
  ],
  communications: [
    { name: '主通信', tool: '短信平台 + 调度电话', holder: '县防汛值班长/镇防汛办', fallback: '电话失败即切到对讲中继' },
    { name: '村内发布', tool: '高音广播 + 警灯 + 手摇警报器', holder: '广播控制员', fallback: '断电时使用发电机和手摇警报器' },
    { name: '路线协同', tool: 'UHF 对讲机 20 部', holder: '路线引导员、交通封控组', fallback: '对讲失败时每 3 分钟派机动补位员往返传令' },
    { name: '回执闭环', tool: '移动端回执 + 纸质清单', holder: '避险点管理员', fallback: '断网时纸质登记，恢复后补录' },
  ],
  control_zones: [
    { zone: '红区', rule: '延河主槽近岸 0-50 m、延河大桥上下游 100 m、沿河首排房屋、西河子沟低洼区和施工临时工棚', action: '强制离开，不设观察点、不堆物资、不停车' },
    { zone: '橙区', rule: '县城临河二排房屋、中心街商铺带、西河子沟沿街低洼区和短时滞留点', action: '警报后 7 分钟内到一级避险点' },
    { zone: '黄区', rule: '延河下游农田作业面、低位道路和农机临停点，只作为穿越撤离区', action: '不长期停留，到一级避险点剩余步行不超过 4 分钟' },
    { zone: '蓝区', rule: '延长县中学、职业教育中心、体育馆（一级）、人民广场（二级）、北山台地（临时）', action: '登记、分区安置、物资发放、医疗照护' },
  ],
  similar_events: [
    { event_id: 'history-2022-datong-0818', title: '青海大通县"8·18"突发山洪复盘', risk_level: 'red', score: 5, summary: '夜间短时强降雨、沟谷快速汇流、可用转移时间极短，适合作为山洪动作链参考。' },
    { event_id: 'history-2023-yanan-0715', title: '2023 延安延河暴雨洪水联动处置', risk_level: 'orange', score: 4, summary: '验证延河上游预警、下游广播、物资前置和避险点登记闭环。' },
    { event_id: 'history-2024-yanchang-drill', title: '延长县山洪灾害防御演练', risk_level: 'orange', score: 4, summary: '重点检验延河穿城段人员转移和支沟回水风险处置。' },
  ],
  owner: '延长县防汛值班长',
  source: 'local_response',
}

const YANCHANG_DRILL = {
  drill_id: 'drill-yanchang',
  sheet_id: YANCHANG_SHEET.sheet_id,
  event_id: YANCHANG_SHEET.event_id,
  status: 'draft',
  title: '延长县县城延河沿线片区防汛应急联动演练方案',
  scenario: '橙色预警条件下，延河上游暴雨洪水与延长县县城人员转移、交通封控、物资前置联动演练',
  objectives: [
    '验证县防汛值班长、社区网格员、村组联络员之间的发令和回执链路。',
    '验证红区、橙区人员 7 分钟内到达一级避险点。',
    '验证砂袋、救生衣、照明、发电机等物资按点位前置和签收。',
    '验证断电、断网、对讲失败情况下的备用通信和人工传令。',
  ],
  steps: [
    { minute: 0, action: '启动防汛会商，确认橙色预警和联动预案', owner: '延长县防汛值班长' },
    { minute: 1, action: '发布广播、短信、对讲指令，打开回执台账', owner: '延长县政府防汛指挥部' },
    { minute: 2, action: '封控延河大桥和沿河低位道路，路线引导员到位', owner: '交通封控与引导组' },
    { minute: 5, action: '红区清户（延河沿岸居民区 + 西河子沟低洼区），特殊人群由担架车和小型转运车接送', owner: '群众转移队' },
    { minute: 7, action: '延长县中学、职教中心、体育馆登记人数，反馈未到人员名单', owner: '医疗救护与安置组' },
    { minute: 15, action: '物资从仓库前置到桥头、避险点和施工营地，完成签收', owner: '物资保障组' },
    { minute: 30, action: '复盘通信失败、路线受阻、人员未到三类异常', owner: '县应急抢险队' },
  ],
  roles: YANCHANG_SHEET.teams.map(team => ({ team: team.name, leader: team.leader, responsibility: team.duty || '执行分配任务并回传处置回执。' })),
  materials: YANCHANG_SHEET.materials,
  routes: YANCHANG_SHEET.evacuation_routes,
  shelters: YANCHANG_SHEET.shelters,
  evaluation: ['预警发出到广播响应用时', '红区清户完成率', '一级避险点到达率', '物资前置签收率', '备用通信启用成功率'],
  schedule: { duration_minutes: 90, start_mode: 'manual' },
  owner: YANCHANG_SHEET.owner,
  source: 'local_response',
}

// ════════════════════════════════════════
// 多场景映射表
// ════════════════════════════════════════
const SCENARIO_MAP = {
  longmen: { scenario: LONGMEN_SCENARIO, sheet: LONGMEN_SHEET, drill: LONGMEN_DRILL },
  yanchang: { scenario: YANCHANG_SCENARIO, sheet: YANCHANG_SHEET, drill: YANCHANG_DRILL },
}

function getActiveBundle() {
  return SCENARIO_MAP[getActiveScenarioKey()] || SCENARIO_MAP.longmen
}

// ── 动态兼容导出 ──
// 这些对象在每次属性访问时动态返回当前场景的数据
// 支持 spread 运算符（{ ...FALLBACK_SCENARIO }）通过 ownKeys + getOwnPropertyDescriptor trap
function buildScenarioObject() {
  const bundle = getActiveBundle()
  return { ...bundle.scenario, gis_data: getActiveScenario() }
}
function buildSheetObject() {
  const bundle = getActiveBundle()
  return { ...bundle.sheet, gis_data: getActiveScenario() }
}

const FALLBACK_SCENARIO = new Proxy({}, {
  get(_t, prop) {
    return buildScenarioObject()[prop]
  },
  ownKeys() {
    return Reflect.ownKeys(buildScenarioObject())
  },
  getOwnPropertyDescriptor(_t, prop) {
    const obj = buildScenarioObject()
    const desc = Object.getOwnPropertyDescriptor(obj, prop)
    if (desc) return { ...desc, configurable: true, enumerable: true }
    return undefined
  },
})

const FALLBACK_SHEET = new Proxy({}, {
  get(_t, prop) {
    return buildSheetObject()[prop]
  },
  ownKeys() {
    return Reflect.ownKeys(buildSheetObject())
  },
  getOwnPropertyDescriptor(_t, prop) {
    const obj = buildSheetObject()
    const desc = Object.getOwnPropertyDescriptor(obj, prop)
    if (desc) return { ...desc, configurable: true, enumerable: true }
    return undefined
  },
})

const FALLBACK_DRILL = new Proxy({}, {
  get(_t, prop) {
    return getActiveBundle().drill[prop]
  },
  ownKeys() {
    return Reflect.ownKeys(getActiveBundle().drill)
  },
  getOwnPropertyDescriptor(_t, prop) {
    const obj = getActiveBundle().drill
    const desc = Object.getOwnPropertyDescriptor(obj, prop)
    if (desc) return { ...desc, configurable: true, enumerable: true }
    return undefined
  },
})

// ════════════════════════════════════════
// API 请求函数（保持不变）
// ════════════════════════════════════════
async function request(path, options = {}) {
  if (GATEWAY_URL === 'local') throw new Error('Emergency API disabled by VUE_APP_HYDRO_API_URL=local')
  const response = await fetch(`${GATEWAY_URL}${path}`, {
    headers: {
      'Content-Type': 'application/json',
      'X-Hydro-Role': 'emergency_manager',
      'X-Hydro-User': 'frontend-emergency-user',
      ...(options.headers || {}),
    },
    ...options,
  })
  if (!response.ok) throw new Error(`${path} responded ${response.status}`)
  return response.json()
}

async function post(path, body) {
  return request(path, { method: 'POST', body: JSON.stringify(body || {}) })
}

export async function listEmergencyEvents() {
  return request('/hydro/emergency/events')
}

export async function createEmergencyEvent(payload = {}) {
  return post('/hydro/emergency/events', payload)
}

export async function generateEmergencySheet(eventId, payload = {}) {
  return post(`/hydro/emergency/events/${eventId}/response-sheet`, payload)
}

export async function exportEmergencySheet(sheetId) {
  return request(`/hydro/emergency/response-sheets/${sheetId}/export`)
}

export async function updateEmergencySheet(sheetId, payload = {}) {
  return request(`/hydro/emergency/response-sheets/${sheetId}`, {
    method: 'PATCH',
    body: JSON.stringify(payload),
  })
}

export async function transitionEmergencySheet(sheetId, payload = {}) {
  return post(`/hydro/emergency/response-sheets/${sheetId}/status`, payload)
}

export async function generateEmergencyDrillPlan(sheetId, payload = {}) {
  return post(`/hydro/emergency/response-sheets/${sheetId}/drill-plan`, payload)
}

export async function updateEmergencyDrillPlan(drillId, payload = {}) {
  return request(`/hydro/emergency/drill-plans/${drillId}`, {
    method: 'PATCH',
    body: JSON.stringify(payload),
  })
}

export async function transitionEmergencyDrillPlan(drillId, payload = {}) {
  return post(`/hydro/emergency/drill-plans/${drillId}/status`, payload)
}

export async function exportEmergencyDrillPlan(drillId) {
  return request(`/hydro/emergency/drill-plans/${drillId}/export`)
}

export async function createEmergencySheetFromScenario(scenarioResult, options = {}) {
  try {
    const event = await createEmergencyEvent({
      title: options.title || '防汛应急联动处置',
      scenario_result: scenarioResult || { ...getActiveBundle().scenario, gis_data: getActiveScenario() },
    })
    const sheet = await generateEmergencySheet(event.event_id, { owner: options.owner || FALLBACK_SHEET.owner })
    return { event: { ...event, source: 'api' }, sheet: enrichEmergencySheet({ ...sheet, source: 'api' }) }
  } catch (error) {
    console.warn('[emergencyService] emergency API unavailable, using fallback sheet:', error)
    const bundle = getActiveBundle()
    return {
      event: {
        event_id: bundle.sheet.event_id,
        title: bundle.scenario.scenario_name,
        source_scenario_id: bundle.scenario.scenario_id,
        risk_level: bundle.sheet.risk_level,
        status: 'sheet_generated',
        source: 'local_response',
      },
      sheet: { ...bundle.sheet, gis_data: getActiveScenario() },
    }
  }
}

function enrichEmergencySheet(sheet = {}) {
  const fallback = { ...getActiveBundle().sheet, gis_data: getActiveScenario() }
  return {
    ...sheet,
    plan_name: sheet.plan_name || fallback.plan_name,
    risk_level: sheet.risk_level || fallback.risk_level,
    gis_data: sheet.gis_data || fallback.gis_data,
    risk_objects: sheet.risk_objects && sheet.risk_objects.length ? sheet.risk_objects : fallback.risk_objects,
    actions: sheet.actions && sheet.actions.length ? sheet.actions : fallback.actions,
    teams: sheet.teams && sheet.teams.length ? sheet.teams : fallback.teams,
    trigger_conditions: sheet.trigger_conditions && sheet.trigger_conditions.length ? sheet.trigger_conditions : fallback.trigger_conditions,
    infrastructure: sheet.infrastructure && sheet.infrastructure.length ? sheet.infrastructure : fallback.infrastructure,
    materials: sheet.materials && sheet.materials.length ? sheet.materials : fallback.materials,
    evacuation_routes: sheet.evacuation_routes && sheet.evacuation_routes.length ? sheet.evacuation_routes : fallback.evacuation_routes,
    shelters: sheet.shelters && sheet.shelters.length ? sheet.shelters : fallback.shelters,
    warning_chain: sheet.warning_chain && sheet.warning_chain.length ? sheet.warning_chain : fallback.warning_chain,
    communications: sheet.communications && sheet.communications.length ? sheet.communications : fallback.communications,
    control_zones: sheet.control_zones && sheet.control_zones.length ? sheet.control_zones : fallback.control_zones,
    similar_events: sheet.similar_events && sheet.similar_events.length ? sheet.similar_events : fallback.similar_events,
    owner: sheet.owner || fallback.owner,
  }
}

export async function generateEmergencyDrillPlanOrFallback(sheet, options = {}) {
  const bundle = getActiveBundle()
  if (!sheet || !sheet.sheet_id || sheet.source === 'local_response') {
    return { ...bundle.drill, sheet_id: sheet?.sheet_id || bundle.sheet.sheet_id, source: 'local_response' }
  }
  try {
    const drill = await generateEmergencyDrillPlan(sheet.sheet_id, {
      owner: options.owner || sheet.owner,
      title: options.title || `${sheet.plan_name}演练方案`,
    })
    return { ...drill, source: 'api' }
  } catch (error) {
    console.warn('[emergencyService] drill API unavailable, using fallback drill:', error)
    return { ...bundle.drill, sheet_id: sheet.sheet_id, event_id: sheet.event_id, source: 'local_response' }
  }
}

export async function exportEmergencySheetOrFallback(sheet) {
  const bundle = getActiveBundle()
  if (!sheet || !sheet.sheet_id || sheet.source === 'local_response') {
    return {
      sheet_id: sheet && sheet.sheet_id ? sheet.sheet_id : bundle.sheet.sheet_id,
      format: 'markdown',
      content: formatSheetAsMarkdown(sheet || { ...bundle.sheet, gis_data: getActiveScenario() }),
    }
  }
  try {
    return await exportEmergencySheet(sheet.sheet_id)
  } catch (error) {
    console.warn('[emergencyService] export API unavailable, formatting locally:', error)
    return { sheet_id: sheet.sheet_id, format: 'markdown', content: formatSheetAsMarkdown(sheet) }
  }
}

export async function exportEmergencyDrillPlanOrFallback(drill) {
  const bundle = getActiveBundle()
  if (!drill || !drill.drill_id || drill.source === 'local_response') {
    return {
      drill_id: drill && drill.drill_id ? drill.drill_id : bundle.drill.drill_id,
      format: 'markdown',
      content: formatDrillAsMarkdown(drill || bundle.drill),
    }
  }
  try {
    return await exportEmergencyDrillPlan(drill.drill_id)
  } catch (error) {
    console.warn('[emergencyService] drill export API unavailable, formatting locally:', error)
    return { drill_id: drill.drill_id, format: 'markdown', content: formatDrillAsMarkdown(drill) }
  }
}

function formatSheetAsMarkdown(sheet) {
  const lines = [
    `# ${sheet.plan_name}`,
    '',
    `- 处置单编号：${formatBusinessId(sheet.sheet_id, '应急处置单')}`,
    `- 事件编号：${formatBusinessId(sheet.event_id, '防汛联动事件')}`,
    `- 风险等级：${formatRiskLevel(sheet.risk_level)}`,
    `- 责任人：${sheet.owner}`,
    '',
    '## 触发条件',
    ...(sheet.trigger_conditions || []).map(item => `- ${item.level}：${item.rule}`),
    '',
    '## 城镇基础设施与防汛设施',
    ...(sheet.infrastructure || []).map(item => `- ${item.name}：${item.type}，${item.role}`),
    '',
    '## 处置措施',
    ...(sheet.actions || []).map(action => `- ${action}`),
    '',
    '## 队伍配置',
    ...(sheet.teams || []).map(team => `- ${team.name}：${team.leader}，${team.members} 人，${team.duty || '按预案执行'}`),
    '',
    '## 物资分配',
    ...(sheet.materials || []).map(item => `- ${item.name}：${item.count} ${item.unit}，仓库：${item.place}，去向：${item.target}`),
    '',
    '## 人员转移路线',
    ...(sheet.evacuation_routes || []).map(route => `- ${route.name}：${route.start} -> ${route.via} -> ${route.end}，步行 ${route.walk_minutes} 分钟，容量 ${route.capacity} 人`),
    '',
    '## 避险与安置点',
    ...(sheet.shelters || []).map(shelter => `- ${shelter.name}：${shelter.level}，容量 ${shelter.capacity} 人，负责人 ${shelter.manager}`),
    '',
    '## 强制动作链',
    ...(sheet.warning_chain || []).map(step => `- T+${step.minute} 分钟：${step.actor}，${step.action}`),
    '',
    '## 通信与失效兜底',
    ...(sheet.communications || []).map(item => `- ${item.name}：${item.tool}，持有人 ${item.holder}，兜底 ${item.fallback}`),
  ]
  return lines.join('\n')
}

function formatDrillAsMarkdown(drill) {
  const lines = [
    `# ${drill.title}`,
    '',
    `- 演练编号：${formatBusinessId(drill.drill_id, '应急演练')}`,
    `- 处置单编号：${formatBusinessId(drill.sheet_id, '应急处置单')}`,
    `- 事件编号：${formatBusinessId(drill.event_id, '防汛联动事件')}`,
    `- 状态：${formatStatus(drill.status)}`,
    `- 责任人：${drill.owner}`,
    '',
    '## 场景',
    drill.scenario,
    '',
    '## 目标',
    ...(drill.objectives || []).map(item => `- ${item}`),
    '',
    '## 步骤',
    ...(drill.steps || []).map(step => `- T+${step.minute || 0} 分钟：${step.action}；责任人：${step.owner}`),
    '',
    '## 路线',
    ...(drill.routes || []).map(route => `- ${route.name}：${route.start} -> ${route.end}`),
    '',
    '## 避险与安置点',
    ...(drill.shelters || []).map(shelter => `- ${shelter.name}：容量 ${shelter.capacity} 人`),
    '',
    '## 评估项',
    ...(drill.evaluation || []).map(item => `- ${item}`),
  ]
  return lines.join('\n')
}

function formatRiskLevel(level) {
  const map = { red: '红色预警', orange: '橙色预警', yellow: '黄色预警', blue: '蓝色预警' }
  return map[level] || level || '待研判'
}

function formatStatus(status) {
  const map = { created: '已创建', draft: '草案编制中', sheet_generated: '处置单已生成', reviewed: '已复核', issued: '已发布', completed: '已完成' }
  return map[status] || status || '待处置'
}

function formatBusinessId(id, prefix) {
  const match = String(id || '').match(/(\d+)$/)
  return match ? `${prefix}第 ${Number(match[1])} 号` : prefix
}

// ════════════════════════════════════════
// 导出
// ════════════════════════════════════════
export { FALLBACK_SCENARIO, FALLBACK_SHEET }

export function getEmergencyGisData() {
  return getActiveScenario()
}

export {
  switchScenario,
  listScenarios,
  getActiveScenarioKey,
  getActiveScenarioInfo,
}
